import {
  type CreateCryptoTransferRequest,
  type CryptoTransfer,
  transferCryptoCreateTransfer,
  transferCryptoGetTransfer,
} from '@column/api';

import type { GetRequestType } from './WireDrawdownRepository';

export type { CryptoTransfer };

// Outgoing stablecoin transfer request. Amount is fiat cents (settled from the bank account's USD balance);
// asset must be USDC. create() maps these camelCase fields onto the snake_case CreateCryptoTransferRequest.
export interface CreateStablecoinTransfer {
  cryptoPaymentAddressId: string;
  cryptoCounterpartyId: string;
  amount: number;
  asset: string;
  description?: string;
  allowOverdraft?: boolean;
  idempotencyKey?: string;
}

export class StablecoinRepository {
  static async create({
    idempotencyKey,
    cryptoPaymentAddressId,
    cryptoCounterpartyId,
    amount,
    asset,
    description,
    allowOverdraft,
  }: CreateStablecoinTransfer): Promise<CryptoTransfer> {
    const body: CreateCryptoTransferRequest = {
      crypto_payment_address_id: cryptoPaymentAddressId,
      crypto_counterparty_id: cryptoCounterpartyId,
      amount,
      asset,
      ...(description !== undefined ? { description } : {}),
      ...(allowOverdraft !== undefined ? { allow_overdraft: allowOverdraft } : {}),
    };

    const { data } = await transferCryptoCreateTransfer({
      body,
      // Dedupe key must ride in the Idempotency-Key header, never the payload; omit it when absent so a retry is not deduped.
      ...(idempotencyKey ? { headers: { 'Idempotency-Key': idempotencyKey } } : {}),
      throwOnError: true,
    });

    return data;
  }

  static async get({ id }: GetRequestType): Promise<CryptoTransfer> {
    const { data } = await transferCryptoGetTransfer({
      path: { crypto_transfer_id: id },
      throwOnError: true,
    });

    return data;
  }
}
